export enum MenuElement {
  DATOS_GENERALES = 'DATOS_GENERALES',
  DATOS_PROPUESTA = 'DATOS_PROPUESTA',
  DATOS_PROYECTO = 'DATOS_PROYECTO',
  BENEFICIARIO = 'BENEFICIARIO',
  PARTICIPANTES = 'PARTICIPANTES',
  PLAN_TRABAJO = 'PLAN_TRABAJO',
  DESGLOSE_FINANCIERO = 'DESGLOSE_FINANCIERO',
  EVALUADORES = 'EVALUADORES',
  DOCUMENTOS = 'DOCUMENTOS',
  DICTAMEN = 'DICTAMEN',
  AYUDANTE = 'AYUDANTE',
  SITUACION_ACTUAL = 'SITUACION_ACTUAL',
  INFORME_MENSUAL = 'INFORME_MENSUAL',
  ACREDITACION = 'ACREDITACION',
  ACREDITACION_SIN_INSTITUCION = 'ACREDITACION_SIN_INSTITUCION',
  DECLARACION_VERACIDAD = 'DECLARACION_VERACIDAD',
  EVALUACION_INDIVIDUAL = 'EVALUACION_INDIVIDUAL',
  VALORACION_INDIVIDUAL = 'VALORACION_INDIVIDUAL',
  EVALUACION_PLENARIA = 'EVALUACION_PLENARIA',
  VALORACION_PLENARIA = 'VALORACION_PLENARIA',
  EVALUACIONES_INDIVIDUALES = 'EVALUACIONES_INDIVIDUALES',
  DICTAMEN_PLENO = 'DICTAMEN_PLENO',
  MATRICULA = 'MATRICULA',
  PROGRAMA = 'PROGRAMA',
  EVALUACION_CONSEJO = 'EVALUACION_CONSEJO',
  RECONSIDERACION = 'RECONSIDERACIÓN',
  RESULTADO = 'RESULTADO',
  RESULTADO_RECONSIDERACION = 'RESULTADO_RECONSIDERACION',
  INSTITUCION = 'INSTITUCION',
  BUSCADOR = 'BUSCADOR',
  REGLAS_PAGO = 'REGLAS_PAGO',
  PADRON = 'PADRON',
  INVESTIGADOR = 'INVESTIGADOR',
  MOVIMIENTO = 'MOVIMIENTO',
  HISTORICO_PAGOS = 'HISTORICO_PAGOS',
  REVISORES = 'REVISORES',
  CONCILIACION = 'CONCILIACION',
  CUOTA = 'CUOTA',
  PLAN_ESTUDIOS = 'PLAN_ESTUDIOS',
  LIES = 'LIES',
  CAMPOS_CONOCIMIENTO = 'CAMPOS_CONOCIMIENTO',
  OPCIONES_TERMINALES = 'OPCIONES_TERMINALES',
  INTEGRADO = 'INTEGRADO',
  REESTRUCTURACION = 'REESTRUCTURACION',
  PRONACES = 'PRONACES',
  CLAUSTRO = 'CLAUSTRO',
  TEMAS = 'TEMAS',
  COMPROBANTE = 'COMPROBANTE',
  ALUMNOS_PROGRAMA = 'ALUMNOS_PROGRAMA',
  FORMALIZACION = 'FORMALIZACION',
  GENERACIONES = 'GENERACIONES',
  DATOS_BECA = 'DATOS_BECA',
  CUESTIONARIO = 'CUESTIONARIO',
  VARIABLES_SOCIODEMOGRAFICAS = 'VARIABLES_SOCIODEMOGRAFICAS',
  CRONOGRAMA_ACTIVIDADES = 'CRONOGRAMA_ACTIVIDADES',
  PERIODO_MOVILIDAD = 'PERIODO_MOVILIDAD',
  CO_TUTOR = 'CO_TUTOR',
  CONTACTOS_EMERGENCIA = 'CONTACTOS_EMERGENCIA',
  DATOS_HIJOS = 'DATOS_HIJOS',
  TIPO_APOYO = 'TIPO_APOYO',
  COORDINADOR = 'COORDINADOR',
  INSTITUCIONES = 'INSTITUCIONES',
  DECLARACIONES = 'DECLARACIONES',
  PERIODO_TUTORIA = 'PERIODO_TUTORIA',
  FIRMA = 'FIRMA',
  ACTIVIDAD = 'ACTIVIDAD',
  BECARIOS = 'BECARIOS',
  ALCANCE = 'ALCANCE',
  POBLACION = 'POBLACION',
  RESULTADOS = 'RESULTADOS',
  VINCULACION = 'VINCULACION',
  TESTIMONIO = 'TESTIMONIO',
  INDICADORES = 'INDICADORES',
}
